import { render } from "./QuoteTypeCard.vue?vue&type=template&id=4ab117fb&scoped=true"
import script from "./QuoteTypeCard.vue?vue&type=script&lang=js"
export * from "./QuoteTypeCard.vue?vue&type=script&lang=js"

import "./QuoteTypeCard.vue?vue&type=style&index=0&id=4ab117fb&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab117fb"]])

export default __exports__